import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-filter2",
  "use": "icon-filter2-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-filter2\">\n<path d=\"M6.43298 5.15918V8.9624L7.80969 10.4556V5.16846L10.9597 1.43848H3.13831L6.43182 5.15918H6.43298ZM0 0H14L9.17352 5.7168V14L5.06915 9.54688V5.72607L0 0Z\" fill=\"#9EA5B2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol